<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-05 18:25:27
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-10 16:22:41
 * @Description: 还款计划
 -->
<template>
  <div class="refund-plan-wrapper">
    <el-table :data="recordList" stripe style="width: 100%">
      <el-table-column prop="period" label="还款期数" width="180"> </el-table-column>
      <el-table-column prop="date" label="应还日期" width="180"> </el-table-column>
      <el-table-column prop="interestOfPrincipal" label="应还本息（元）"> </el-table-column>
      <el-table-column prop="principal" label="应还本金（元）"> </el-table-column>
      <el-table-column prop="interests" label="应还利息（元）"> </el-table-column>
      <el-table-column prop="rest" label="剩余本金（元）"> </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'refund-plan',
  props: {
    propsData: Object,
    default: () => {
      return {
        refundPlan: []
      };
    }
  },
  data() {
    return {
      // recordList: [
      //   {
      //     period: 3,
      //     date: '2019-07-08',
      //     interestOfPrincipal: '6,576.03',
      //     principal: '6,576.03',
      //     interests: '443.34',
      //     rest: '69,867.30'
      //   }
      // ]
    };
  },
  computed: {
    recordList() {
      return this.propsData.refundPlan;
    }
  }
};
</script>
<style lang="less" scoped>
.refund-plan-wrapper {
  padding: 20px;
}
</style>
